<script lang="ts" setup>
import { useModal } from 'vue-final-modal'

import BasicButton from '~/components/form-elements/BasicButton.vue'
import CreateProductQuestion from '~/components/modal-windows/CreateProductQuestion.vue'
import ProductTitle from '~/components/products/ProductTitle.vue'
import ProductQuestionItem from '~/components/supplier/ProductQuestionItem.vue'
import AuthScope from '~/enums/auth-scope'
import UserPermission from '~/enums/user-permission'
import { useProductQuestionsStore } from '~/store/product-questions'
import { useUserStore } from '~/store/user'

const props = defineProps<{
  productId: string | null
}>()

const productQuestionsStore = useProductQuestionsStore()
const userStore = useUserStore()

async function openCreateProductQuestionModalWindow (): Promise<void> {
  await useModal({ component: CreateProductQuestion, attrs: { productId: props.productId! } }).open()
}

async function changePage (pageNumber: number): Promise<void> {
  window.scrollTo(0, 0)

  productQuestionsStore.page.number = pageNumber

  await loadData()
}

async function loadData (): Promise<void> {
  await productQuestionsStore.fetchProductQuestions(AuthScope.Client)
}

onMounted(async (): Promise<void> => {
  productQuestionsStore.filter.productId = props.productId
  productQuestionsStore.page.number = 1

  await loadData()
})

onUnmounted(productQuestionsStore.dispose)
</script>

<template>
  <section>
    <div class="mb-6 flex items-center justify-between">
      <ProductTitle :title="'Вопросы о\xA0товаре'" />

      <BasicButton
        v-if="userStore.hasPermission(UserPermission.ClientCreateProductQuestion)"
        color="green"
        is-small
        title="Написать вопрос"
        @click="openCreateProductQuestionModalWindow"
      />
    </div>

    <template v-if="productQuestionsStore.productQuestionsData.length">
      <div v-for="x in productQuestionsStore.productQuestionsData" :key="x.id" class="mb-6">
        <ProductQuestionItem :product-question-data="x" />
      </div>
    </template>
    <Notification v-else status="info">
      Нет вопросов о&nbsp;товаре.
    </Notification>

    <Pagination
      class="mt-6"
      :current-page="productQuestionsStore.page.number"
      :last-page="productQuestionsStore.totalPages"
      @change-page="changePage"
    />
  </section>
</template>
